import { message } from "antd";
import status from "./status";
import i18n from "../locales/i18n";
import Cookies from "js-cookie";
import api_domain_config from "../views/account/constants/common";
import store from "../views/account/redux/store";

const request = (url, options) => {
  let controller = new AbortController(); //可用于中止fetch请求
  let HTTPUrl = url;
  let HTTPOptions = { method: "GET", signal: controller.signal };
  // Consolidation request
  Object.assign(HTTPOptions, options);

  //GET Method: query characters are attached to url behind;
  if ((HTTPOptions.method === "GET" && options.data) || HTTPOptions.method === "HEAD") {
    let searchStr = "";
    if (options.data instanceof Object) {
      for (let i in options.data) {
        searchStr += i + "=" + options.data[i];
      }
    }
    HTTPUrl = url + "?" + searchStr;
  }

  console.log(HTTPOptions);
  return new Promise((resolve, reject) => {
    fetch(HTTPUrl, HTTPOptions)
      .then(res => {
        return res.json();
      })
      .then(res => {
        if (res && res.code) {
          if (res.code === 401) {
            window.location.replace(`${window.location.origin}/v2/account.html#/login`);
            Cookies.remove("authorization", { domain: api_domain_config.DOMAIN });
            store.dispatch({
              type: "AUTHORIZATION",
              authorization: null,
            });
          }
          if (res.code !== 200) {
            if (status[res.code]) {
              message.warn(status[res.code]);
            } else {
              message.warn(i18n.t("common:serverErrorTips"));
            }
          }
          resolve(res);
          //为了兼容 feedback 的服务器返回格式
        } else if (res && res.status) {
          if (res.status === 200) {
            resolve(res);
          } else {
            if (status[res.status]) {
              message.warn(status[res.status]);
            } else {
              message.warn(i18n.t("common:serverErrorTips"));
            }
            resolve(res);
          }
        } else {
          message.warn(i18n.t("common:serverErrorTips"));
          resolve(res);
        }
      })
      .catch(error => {
        if (error.name === "AbortError") {
          console.log("Fetch was aborted");
        } else {
          message.warn(i18n.t("common:serverErrorTips"));
          reject(error);
        }
      });
  });
};

export default request;
